import React, { useEffect } from 'react'; // Import useEffect
import { Grid, Typography, Box } from '@mui/material';
import ServiceCard from '../components/ServiceCard';
import SEO from '../components/SEO';

const services = [
  {
    title: 'Wedding Events',
    description: 'Elegant Lights for Your Wedding',
    image: '/images/Fair6.jpg',
    link: '/wedding',
  },
  // {
  //   title: 'Birthday Parties',
  //   description: 'Sparkling Lights to Brighten Your Birthday Bash',
  //   image: '/birthday.jpg',
  //   link: '/birthday-parties',
  // },
  // {
  //   title: 'Christmas Parties',
  //   description: 'Sparkle Bright This Christmas Season',
  //   image: '/christmas.jpg',
  //   link: '/christmas-parties',
  // },
  {
    title: 'Religious Festival',
    description: 'Sacred Glow for Holy Events',
    image: '/images/Temp2.jpg',
    link: '/religious-festivals',
  },
];

const Event = ({ darkMode }) => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO 
        title="Event Lighting Services Colombo | Event Lighting Western Province | Party Lighting Sri Lanka"
        description="Professional event lighting services in Colombo, Western Province, Gampaha, Kalutara. Corporate event lighting, party lighting, wedding events, religious festivals. කොළඹ උත්සව ආලෝක සේවා | වෙස්ටර්න් ප්‍රොවින්ස් උත්සව ආලෝකය. Best event lighting near me in Sri Lanka."
        keywords="event lighting services Colombo, කොළඹ උත්සව ආලෝක සේවා, event lighting Western Province, වෙස්ටර්න් ප්‍රොවින්ස් උත්සව ආලෝකය, event lighting near me Sri Lanka, මට ලඟ උත්සව ආලෝක සේවා ශ්‍රී ලංකාවේ, lighting decoration Colombo, කොළඹ ලයිට් සැරසිලි, lighting decoration Western Province, වෙස්ටර්න් ප්‍රොවින්ස් ලයිට් සැරසිලි, party lighting services Western Province, වෙස්ටර්න් ප්‍රොවින්ස් පාටි ලයිටින් සේවා, Colombo event lighting & decoration, කොළඹ උත්සව ලයිටින් සහ සැරසිලි, Gampaha lighting services, ගම්පහ ලයිටින් සේවා, Kalutara event lights & decoration, කළුතර උත්සව ලයිට් සහ සැරසිලි, outdoor event lighting Sri Lanka, ශ්‍රී ලංකාවේ බාහිර උත්සව ලයිටින්, stage and party lighting Colombo, කොළඹ ස්ටේජ් සහ පාටි ලයිටින්, corporate event lighting Sri Lanka, ශ්‍රී ලංකා කෝපරේට් උත්සව ලයිටින්, event, events, event lighting, functions, function lighting, wedding events, birthday events, Christmas events, Kathina event, Vesak event, Poson event, religious festivals, temple events, decorations, event decorations, celebration lighting, corporate events, private functions, party lighting, Sri Lanka events, Colombo events, Miracle Lighting"
        url="https://miraclelighting.lk/event"
      />
      
      <Box
      sx={{
        py: { xs: 6, sm: 10, md: 15 },
        px: { xs: 3, sm: 10, md: 15 },
        textAlign: 'center',
        backgroundColor: darkMode ? '#000000' : '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
                  variant="h3"
                  gutterBottom
                  sx={{
                    mt: 5,
                    mb: 5,
                    color: darkMode ? '#FFD700' : '#000000',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    textShadow: darkMode ? '0 2px 4px rgba(255, 215, 0, 0.5)' : '0 2px 4px rgba(0, 0, 0, 0.2)',
                    position: 'relative',
                  
                  }}
                >
        Our Main Events
      </Typography>
      
      <Grid container spacing={4} justifyContent="center">
        {services.map((service) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={service.title}>
            <ServiceCard
              title={service.title}
              description={service.description}
              image={service.image}
              link={service.link}
              darkMode={darkMode}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
    </>
  );
};

export default Event;